import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useAccountModel } from "../account/accountModel";
import { useTransferModel } from "./transferModel";
import { useDetailModel } from "../detailModel";


export const TransferSearchBox = () => {
    const {
        supplierUserDs,
    } = useAccountModel();
    const {
        orgDs,
        beDs
    } = useDetailModel(model => [model.orgDs, model.beDs]);
    const {
        onReset,
        searchParam,
        onSearch,
        updateSearchParam,
    } = useTransferModel()

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "转入账户",
            fieldName: "accountInCode",
            size: "small",
            options: supplierUserDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "转出账户",
            fieldName: "accountOutCode",
            size: "small",
            options: supplierUserDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            format: "YYYY-MM-DD",
            size: "small",
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    transferTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
            }
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset
        },
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
